<template>
  <!--角色管理 -->
  <div class="newsPage">
    <div>
      <el-card style="margin: 30px">
        <div style="display: flex;align-items: center">
          <div>审核状态：</div>
          <el-select v-model="examineStatus" size="small" style="width: 180px;margin-right: 10px" clearable placeholder="请选择审核状态">
            <el-option
                v-for="item in [{'key':0,'value':'审核中'},{'key':1,'value':'审核通过'},{'key':2,'value':'审核未通过'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
          <div>话题标题：</div>
          <el-input clearable placeholder="请输入搜索内容" size="small" style="width: 180px;margin-right: 10px" v-model="topicTitle"></el-input>
          <div>创建时间：</div>
          <el-date-picker
              v-model="dateValue"
              :clearable="false"
              @change="dateChange"
              type="daterange"
              size="small"
              style="margin-right: 10px"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
          <el-button size="small" type="primary" @click="searchBtn">查询</el-button>
          <el-button size="small" type="danger" @click="resetBtn">重置</el-button>
          <el-button size="small" type="success" @click="addBtn">新增</el-button>
          <el-button @click="batchTakeUpBtn" v-if="cantakeUpIds&&cantakeUpIds.length" size="small" type="danger">批量上架</el-button>
          <el-button @click="batchTakeDownBtn" v-if="canTakeDownIds&&canTakeDownIds.length" size="small" type="danger">批量下架</el-button>
        </div>

        <el-table
            size="small"
            tooltip-effect="dark"
            ref="multipleTable"
            @selection-change="handleSelectionChange"
            :data="tableData"
            border
            style="width: 100%;margin-top: 30px"
        >
          <el-table-column
              type="selection"
              align="center"
              width="55">
          </el-table-column>
          <el-table-column label="话题标题" width="230" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{scope.row.topic_title}}
                </template>
                <span style="width:210px;height:40px;display: -webkit-box;-webkit-box-orient: vertical;text-overflow: ellipsis;-webkit-line-clamp: 2;overflow : hidden;">{{ scope.row.topic_title }}</span>
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="摘要" width="230" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{scope.row.abstract}}
                </template>
                <span style="width:210px;height:40px;display: -webkit-box;-webkit-box-orient: vertical;text-overflow: ellipsis;-webkit-line-clamp: 2;overflow : hidden;">{{ scope.row.abstract }}</span>
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="封面图" align="center">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-image
                    style="width: 160px; height: 80px"
                    :src="scope.row.cover_url"
                    :preview-src-list="scope.row.cover_urlList">
                </el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="背景图" align="center">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-image
                    style="width: 160px; height: 80px"
                    :src="scope.row.background_url"
                    :preview-src-list="scope.row.background_urlList">
                </el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="参与人数" width="100" prop="participate_count" align="center"></el-table-column>
          <el-table-column label="阅读人数" width="100" prop="read_count" align="center"></el-table-column>
          <el-table-column header-align="center" width="120" label="审核状态">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-tag v-if="scope.row.examine_status === 0" type="warning" size="small" effect="dark">审核中</el-tag>
                <el-tag v-if="scope.row.examine_status === 1" type="success" size="small" effect="dark">审核通过</el-tag>
                <el-tag v-if="scope.row.examine_status === 2" type="danger" size="small" effect="dark">审核未通过</el-tag>
                <el-tag v-if="scope.row.examine_status === 3" type="info" size="small" effect="dark">已下架</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="120" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{scope.row.create_date}}
                </template>
                {{ scope.row.create_date_list[0] }}
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="操作"
              width="300"
          >
            <template slot-scope="scope">
              <el-button @click="editBtn(scope.row)" v-if="scope.row.examine_status === 0 || scope.row.examine_status === 3 || scope.row.examine_status === 2 " size="small" type="success">修改</el-button>
              <el-button @click="takeDownBtn(scope.row)" v-if="scope.row.examine_status === 1" size="small" type="danger">下架</el-button>
              <el-button @click="takeUpBtn(scope.row)" v-if="scope.row.examine_status === 2 || scope.row.examine_status === 3" size="small" type="danger">上架</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="display: flex;justify-content: center;margin-top: 20px"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[20, 30, 40, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements">
        </el-pagination>
      </el-card>
    </div>

    <a-modal
        :visible="addDialogState"
        cancel-text="取消"
        ok-text="确认"
        :title="dialogTitle"
        width="500px"
        @cancel="addCancel"
        @ok="addSubmit('ruleForm')"
    >
      <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-form-item label="话题标题" prop="topicTitle">
          <el-input v-model="ruleForm.topicTitle" style="width: 300px" size="small" placeholder="请输入话题标题"></el-input>
        </el-form-item>
        <el-form-item label="话题摘要" prop="abstract">
          <el-input v-model="ruleForm.abstract" type="textarea" :rows="5" style="width: 300px" size="small" placeholder="请输入话题摘要"></el-input>
        </el-form-item>
        <el-form-item label="封面图片" prop="coverUrl">
          <el-upload
              :before-upload="coverUrlBeforeAvatarUpload"
              :on-success="coverUrlHandleAvatarSuccess"
              :show-file-list="false"
              :action="uploadApiUrl"
              class="cover-uploader">
            <img v-if="ruleForm.coverUrl" :src="ruleForm.coverUrl" class="cover">
            <i v-else class="el-icon-plus cover-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="背景图片" prop="backgroundUrl">
          <el-upload
              :before-upload="backgroundUrlBeforeAvatarUpload"
              :on-success="backgroundUrlHandleAvatarSuccess"
              :show-file-list="false"
              :action="uploadApiUrl"
              class="cover-uploader">
            <img v-if="ruleForm.backgroundUrl" :src="ruleForm.backgroundUrl" class="cover">
            <i v-else class="el-icon-plus cover-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
    </a-modal>

    <!--    下架的弹窗-->
    <a-modal
        title="提示"
        :visible="takeDownDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="400px"
        @cancel="takeDownCancel"
        @ok="takeDownSubmit"
    >
      <div>{{simpleTakeDown?'是否下架该话题？':'是否下架当前所选中的话题？'}}</div>
    </a-modal>

  </div>
</template>
<script>
import moment from "moment";
import { baseURL } from "@/api/config";

export default {
  data() {
    return {
      dialogTitle:'',
      pageNum: 1,
      pageSize: 20,
      examineStatus:null,
      topicTitle:'',
      dateValue:'',
      createStartDate:'',
      createEndDate:'',
      tableData:[],
      totalElements: 0,//数据总数
      addDialogState:false,
      ruleForm:{
        id:null,
        sysUserId:localStorage.getItem("loginId"),
        topicTitle:'',
        abstract:'',
        coverUrl:'',
        backgroundUrl:''
      },
      rules:{
        topicTitle: [{required: true, message: "请输入话题标题", trigger: "blur"}],
        abstract: [{required: true, message: "请输入话题摘要", trigger: "blur"}],
        coverUrl: [{required: true, message: "请上传封面图片", trigger: "blur"}],
        backgroundUrl: [{required: true, message: "请上传背景图片", trigger: "blur"}],
      },
      uploadApiUrl:'',
      multipleSelection:[],
      canTakeDownIds:[],//批量下架的id组
      cantakeUpIds:[],//批量上架的id组
      takeDownDialogState:false,
      simpleTakeDown:false,
      takeDownId:''
    };
  },
  methods: {
    searchBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.getNewsList()
    },
    resetBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.examineStatus = null
      this.topicTitle = ''
      this.createStartDate = ''
      this.createEndDate = ''
      this.dateValue = ''
      this.getNewsList()
    },
    addBtn(){
      this.dialogTitle = '新增'
      this.ruleForm.id = null
      this.ruleForm.topicTitle = ''
      this.ruleForm.abstract = ''
      this.ruleForm.coverUrl = ''
      this.ruleForm.backgroundUrl = ''
      this.addDialogState = true
    },
    editBtn(row){
      this.dialogTitle = '编辑'
      this.ruleForm.id = row.id
      this.ruleForm.topicTitle = row.topic_title
      this.ruleForm.abstract = row.abstract
      this.ruleForm.coverUrl = row.cover_url
      this.ruleForm.backgroundUrl = row.background_url
      this.addDialogState = true
    },
    takeDownBtn(row){
      this.simpleTakeDown = true
      this.takeDownId = row.id
      this.takeDownDialogState = true
    },
    takeDownCancel(){
      this.takeDownDialogState = false
    },
    takeDownSubmit(){
      if (this.simpleTakeDown){
        //单个下架
        this.postAxios("/topic/updTopicShelfByIds", {
          examineStatus:3,
          ids:[this.takeDownId]
        }).then(res=>{
          if (res.success){
            this.$message.success("下架成功!")
            this.takeDownId = ''
            this.takeDownDialogState = false
            this.getNewsList()
          }
        })
      }else{
        //多个下架
        this.postAxios("/topic/updTopicShelfByIds",{
          examineStatus:3,
          ids:this.canTakeDownIds
        }).then(res => {
          if (res.success) {
            this.$message.success("已下架" + this.canTakeDownIds.length + '条数据!')
            this.takeDownDialogState = false
            this.getNewsList()
          }
        });
      }
    },
    batchTakeDownBtn(){
      this.simpleTakeDown = false
      this.takeDownDialogState = true
    },
    takeUpBtn(row){
      this.postAxios("/topic/updTopicShelfByIds",{
        examineStatus:0,
        ids:[row.id]
      }).then(res => {
        if (res.success) {
          this.$message.success("上架成功!")
          this.getNewsList()
        }
      });
    },
    batchTakeUpBtn(){
      this.postAxios("/topic/updTopicShelfByIds",{
        examineStatus:0,
        ids:this.cantakeUpIds
      }).then(res => {
        if (res.success) {
          this.$message.success("已上架" + this.cantakeUpIds.length + '条数据!')
          this.getNewsList()
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.canTakeDownIds = []
      this.cantakeUpIds = []
      this.multipleSelection.forEach((item)=>{
        if (item.examine_status === 1){
          this.canTakeDownIds.push(item.id)
        }else if (item.examine_status === 3){
          this.cantakeUpIds.push(item.id)
        }
      })
    },
    addCancel() {
      this.addDialogState = false
      this.$refs.ruleForm.clearValidate();
    },
    addSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogTitle === '新增'){
            this.postAxios("/topic/addTopic", this.ruleForm).then(res => {
              if (res.success) {
                this.$message.success("添加成功!")
                this.addDialogState = false
                this.getNewsList()
              }
            });
          }else{
            this.postAxios("/topic/updTopicForBackgroundEdit", this.ruleForm).then(res => {
              if (res.success) {
                this.$message.success("修改成功!")
                this.addDialogState = false
                this.getNewsList()
              }
            });
          }
        }
      });
    },
    coverUrlHandleAvatarSuccess(res) {
      if (res.success) {
        this.ruleForm.coverUrl = res.entity;
      }
    },
    coverUrlBeforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    backgroundUrlHandleAvatarSuccess(res) {
      if (res.success) {
        this.ruleForm.backgroundUrl = res.entity;
      }
    },
    backgroundUrlBeforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    dateChange(e){
      this.dateValue = e
      this.createStartDate = moment(this.dateValue[0]).format('YYYY-MM-DD')
      this.createEndDate = moment(this.dateValue[1]).format('YYYY-MM-DD')
    },
    getNewsList() {
      this.postAxios("/topic/selTopicForBackgroundEdit", {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        parameterMap: {
          sysUserId:localStorage.getItem("loginId"),
          topicTitle:this.topicTitle,
          examineStatus: this.examineStatus === '' ? null : this.examineStatus,
          createStartDate: this.createStartDate,
          createEndDate: this.createEndDate,
        }
      }).then(res => {
        if (res.success) {
          this.tableData = []
          this.tableData = res.content;
          this.tableData.forEach((item)=>{
            item.cover_urlList = []
            item.background_urlList = []
            item.create_date_list = item.create_date.split(' ')
            if (item.cover_url){
              item.cover_urlList.push(item.cover_url)
            }
            if (item.background_url){
              item.background_urlList.push(item.background_url)
            }
          })
          this.totalElements = res.totalCount
        } else {
          this.tableData = []
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getNewsList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getNewsList()
    }
  },
  created() {
    this.uploadApiUrl = baseURL + '/file/uploadUserHeadImg'
    console.log(localStorage.getItem("loginId"),this.uploadApiUrl)
    this.getNewsList();
  }
};
</script>
<style lang="less" scoped>
.cover-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.cover-uploader .el-upload:hover {
  border-color: #409EFF;
}

.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  border: 1px dashed #d9d9d9;
  width: 300px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.cover {
  width: 300px;
  height: 150px;
  display: block;
}
</style>
